{
    "ACDStatusHotKeys_Success_Available": "Agent \"{}\" is beschikbaar",
    "ACDStatusHotKeys_Success_Unavailable": "Agent \"{}\" is niet beschikbaar",
    "ACDStatusHotKeys_Error_CannotSetUserToAvailable": "Kon \"{}\" niet instellen op beschikbaar.\nDeze agent is mogelijk al beschikbaar of afgemeld.",
    "ACDStatusHotKeys_Error_CannotSetUserToUnavailable": "Kon \"{}\" niet instellen op onbeschikbaar.\nDeze agent is mogelijk al niet beschikbaar of afgemeld.",
    "NAME": "ACDStatusHotKeys"
}